import { TeaserCardProps, TeaserCard as TeaserComponent } from '@almbrand/teasercard';
import styles from './TeaserCardComponent.module.scss';

interface TeaserCardButton {
	title?: string;
	link?: Link;
	target?: '_self' | '_blank';
	type?: string;
	color?: string;
}

interface TeaserCardComponentProps extends Omit<
	TeaserCardProps,
	'backgroundColor' | 'content' | 'media' | 'ctaGroupProps'
> {
	contentId?: number;
	image?: Image;
	imgHeight?: string;
	textArea?: string;
	buttons?: TeaserCardButton[];
	backgroundColor?: { cssClass?: string };
}

const buttonTypes = ['primary', 'secondary', 'tertiary', 'personal', 'link', 'downloadLink', 'circle'] as const;

const getButtonType = (color?: string) => {
	return buttonTypes.find((buttonType) => buttonType === color);
};

export const TeaserCardComponent: React.FC<TeaserCardComponentProps> = ({ backgroundColor, ...props }) => {
	const { contentId, image, imgHeight, textArea, buttons, ...cardProps } = props;

	const ctaButtons =
		buttons
			?.filter((button) => button.title)
			.map((button) => ({
				children: button.title,
				buttonType: getButtonType(button.color),
				linkButtonSettings: button.link?.url
					? {
							href: button.link.url,
							target: button.target ?? button.link.target ?? '_self',
							title: button.title,
						}
					: undefined,
			})) ?? [];

	return (
		<TeaserComponent
			id={contentId}
			content={textArea}
			media={
				image?.url
					? {
							url: image.url,
							size: imgHeight === 'sm' ? 'small' : 'large',
							type: 'image',
							altText: image.properties?.altText ?? '',
						}
					: undefined
			}
			ctaGroupProps={ctaButtons.length > 0 ? { ctaGroup: ctaButtons } : undefined}
			backgroundColor={backgroundColor?.cssClass}
			className={styles.TeaserCardComponent}
			{...cardProps}
		/>
	);
};
